import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import Splash from "./components/splash";
import { BrowserRouter } from "react-router-dom";
import "./styles/global.css";

function LoadSite() {
	const [splash, setsplash] = useState(true);
	useEffect(() => {
		window.setTimeout(() => {
			setsplash(false);
		}, 3000);
	}, []);

	return splash ? <Splash /> : <App />;
}

ReactDOM.render(
	<React.StrictMode>
		<BrowserRouter>
			<LoadSite />
		</BrowserRouter>
	</React.StrictMode>,
	document.getElementById("root")
);
